import * as Cesium from 'cesium';
import BaseLayer from "./baseLayer";
import CONSTANTS from "../constants";
/**
 * 报警图层
 */
class AlarmLayer extends BaseLayer{

    constructor(options={}){
        options.layerName=options.layerName||CONSTANTS.LAYER.ALARM;//图层名
        super(options);
    }

    addEntities(alarms,data){
        let self=this;
        self.clearLayer();
        data.forEach((obj,index) =>{
            let item={...obj.attributes};
            item.layerName=self.layerName;
            //判断是否存在报警
            let _alarms=alarms.filter(item1=>item1.dangerInfoId==item.dangerInfoId);
            if(_alarms.length>0){
                // 呼吸灯效果;
                let alp = 1;
                let num = 0;
                let positions=[];
                for (let i = 0; i < item.coors.length; i++) {
                    let coor = item.coors[i].coor;
                    positions.push(Cesium.Cartesian3.fromDegrees(Number(coor[0]),Number(coor[1]), CONSTANTS.ALTITUDE));
                }

                let polygon=new Cesium.Entity({
                    show:true,
                    name: item.name,
                    polygon: {
                        hierarchy: positions,
                        extrudedHeight: Number(item.hight),
                        material: new Cesium.ImageMaterialProperty({
                            image:"/static/imgs/tube.jpg",
                            transparent:true,
                            color:new Cesium.CallbackProperty(function () {
                                if ((num % 2) === 0){
                                    alp -=0.205;
                                }else {
                                    alp +=0.205;
                                }

                                if (alp <= 0.3){
                                    num++;
                                }else if (alp >= 1){
                                    num++;
                                }
                                return  Cesium.Color.WHITE.withAlpha(alp)
                                //entity的颜色透明 并不影响材质，并且 entity也会透明
                            },false)
                        }),
                        closeTop: true,
                        closeBottom: true
                    }
                });
                self.dataSource.entities.add(polygon);
            }
        });
    }
}
export default AlarmLayer;
